/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G-Force Calculator (RCF)`)
};

const es_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Fuerza G (RCF)`)
};

const de_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G-Kraft-Rechner (RCF)`)
};

const nl_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G-krachtcalculator (RCF)`)
};

const fr_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de force g (RCF)`)
};

const it_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore forza G (RCF)`)
};

const pt_br2_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Força G (RCF)`)
};

const pt_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Força G (RCF)`)
};

const ja_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遠心力計算機(RCF)`)
};

const zh_gf_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离心力计算器 (RCF)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_h1", locale)
	if (locale === "en") return en_gf_h1(inputs)
	if (locale === "es") return es_gf_h1(inputs)
	if (locale === "de") return de_gf_h1(inputs)
	if (locale === "nl") return nl_gf_h1(inputs)
	if (locale === "fr") return fr_gf_h1(inputs)
	if (locale === "it") return it_gf_h1(inputs)
	if (locale === "pt-BR") return pt_br2_gf_h1(inputs)
	if (locale === "pt") return pt_gf_h1(inputs)
	if (locale === "ja") return ja_gf_h1(inputs)
	return zh_gf_h1(inputs)
};